import {priority} from '@priority-software/priority-proto-api/lib';
import texts from '../../texts';
import {PredictiveModelDateOption} from '../../consts';

export const buildGroupTitleOptions = () => [
    {
        value: priority.netitems.nrest.RepColHeaderModes.RepColHeaderModes_None,
        label: '--'
    },
    {
        value: priority.netitems.nrest.RepColHeaderModes.RepColHeaderModes_NewHeader,
        label: texts.fieldsTableGroupMain
    },
    {
        value: priority.netitems.nrest.RepColHeaderModes.RepColHeaderModes_AppendToHeader,
        label: texts.fieldsTableGroupSecondary
    }
];

export const buildFunctionsOptions = () => [
    {
        value: priority.netitems.nrest.RepColFunc.RepColFunc_None,
        label: '--'
    },
    {
        value: priority.netitems.nrest.RepColFunc.RepColFunc_Sum,
        label: texts.fieldsTableFunctionSum
    },
    {
        value: priority.netitems.nrest.RepColFunc.RepColFunc_Avg,
        label: texts.fieldsTableFunctionAvg
    },
    {
        value: priority.netitems.nrest.RepColFunc.RepColFunc_Max,
        label: texts.fieldsTableFunctionMax
    },
    {
        value: priority.netitems.nrest.RepColFunc.RepColFunc_Min,
        label: texts.fieldsTableFunctionMin
    }
];

export const buildGroupFunctionsOptions = reportColumns => {
    const hasNonZeroGroup = reportColumns.some(column => column.Group !== 0);
    if (hasNonZeroGroup) {
        return [
            {
                value: priority.netitems.nrest.RepGroupFunc.RepGroupFunc_None,
                label: texts.fieldsTablegroupNone
            },
            {
                value: priority.netitems.nrest.RepGroupFunc.RepGroupFunc_Group,
                label: texts.fieldsTableGroupTotalOnly
            },
            {
                value: priority.netitems.nrest.RepGroupFunc.RepGroupFunc_Report,
                label: texts.fieldsTableReportTotalOnly
            },
            {
                value: priority.netitems.nrest.RepGroupFunc.RepGroupFunc_Both,
                label: texts.fieldsTableTotalBoth
            },
            {
                value: priority.netitems.nrest.RepGroupFunc.RepGroupFunc_RepeatValue,
                label: texts.fieldsTableRepeatValue
            }
        ];
    }

    return [
        {
            value: priority.netitems.nrest.RepGroupFunc.RepGroupFunc_None,
            label: texts.fieldsTablegroupNone
        },
        {
            value: priority.netitems.nrest.RepGroupFunc.RepGroupFunc_Report,
            label: texts.fieldsTableReportTotalOnly
        }
    ];
};

export const buildGroupOptions = (columns: priority.netitems.nrest.IReportCol[]) => [
    {value: 0, label: '--'},
    ...columns.map((col, index) => ({
        value: index + 1,
        label: (index + 1).toString(),
        isSelected: columns.some(report => Number(report.Group) === index + 1)
    }))
];

export const buildSortOptions = (columns: priority.netitems.nrest.IReportCol[]) => [
    {value: 0, label: '--'},
    ...columns.map((col, index) => ({
        value: index + 1,
        label: (index + 1).toString(),
        isSelected: columns.some(report => Number(report.Sort) === index + 1)
    }))
];

export const buildPredictiveModelDateOptions = () => {
    return [
        {label: texts.predictiveModelMonthlyOption, value: PredictiveModelDateOption.Monthly},
        {label: texts.predictiveModelQuarterlyOption, value: PredictiveModelDateOption.Quarterly},
        {
            label: texts.predictiveModelSemiannualOption,
            value: PredictiveModelDateOption.Semiannually
        },
        {label: texts.predictiveModelAnnualOption, value: PredictiveModelDateOption.Annually}
    ];
};
